import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export default new EnumItem({
  NO: {
    text: i18n.gettext('默认') + '(10:00-22:00)',
    value: 0
  },
  YES: {
    text: i18n.gettext('自定义'),
    value: 1
  }
})